import { api } from '../core';
import { BundleSectionsTreeNode, refreshBundleSectionsWithCurrentFilters } from './getBundleSections';
import { RootState } from '@/store';

interface ReorderBundleSectionsResponse {
  pageIds: string[];
  sidebar: BundleSectionsTreeNode[];
}

interface ReorderBundleSectionsProps {
  bundleId: string;
  targetParentId: string;
  targetIndex: number;
  // Neighbour section ids on either side of the drop slot. null means the
  // block is at the top (before) or bottom (after) of the target parent.
  sectionBeforeTarget: string | null;
  sectionAfterTarget: string | null;
  childSections: string[];
  abortController?: AbortController;
}

const reorderBundleSectionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    reorderBundleSections: builder.query<ReorderBundleSectionsResponse, ReorderBundleSectionsProps>({
      query: ({
        bundleId,
        targetParentId,
        targetIndex,
        sectionBeforeTarget,
        sectionAfterTarget,
        childSections,
        abortController = new AbortController(),
      }: ReorderBundleSectionsProps) => ({
        url: 'bundle/section/reorder',
        method: 'POST',
        signal: abortController.signal,
        body: {
          bundle_id: bundleId,
          target_parent_id: targetParentId,
          // target_index kept for backwards compatibility until the neighbour
          // -based endpoint deploys; section_before/after_target is preferred.
          target_index: targetIndex,
          section_before_target: sectionBeforeTarget,
          section_after_target: sectionAfterTarget,
          child_sections: childSections,
        },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;

          //** Used optimistic data update in the component */
          // const { data } = await queryFulfilled;
          // const state = getState() as RootState;

          // const getBundlePageIdByPageIndex = makeSelectBundlePageIdByPageIndex(state);
          // const currentPageId = getBundlePageIdByPageIndex(state.bundleViewportData.viewportPageIndexInStore);

          // if (state.sharedData.activeBundleType) {
          //   dispatch(setViewportPageIdForRestorePageIndexInStore(currentPageId));
          refreshBundleSectionsWithCurrentFilters(dispatch, state);
          // }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in reorderBundleSections in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyReorderBundleSectionsQuery } = reorderBundleSectionsApi;
